import { useEffect, useState } from "react";
import DashboardShell from "../components/DashboardShell";
import PostComposer from "../components/PostComposer";
import PostCard from "../components/PostCard";
import { TrendingHashtags, SuggestedAccounts } from "../components/Sidebars";
import FeedSkeleton from "../components/FeedSkeleton";
import BackToTop from "../components/BackToTop";
import { api } from "../lib/api";

const PAGE_SIZE = 20;

export default function NewsFeed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/feed`, { params: { limit: PAGE_SIZE } });
      setItems(data.items || []);
      setHasMore((data.items || []).length === PAGE_SIZE);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (loadingMore || !hasMore || items.length === 0) return;
    setLoadingMore(true);
    try {
      const last = items[items.length - 1];
      const before = last?.created_at;
      const { data } = await api.get(`/feed`, { params: { limit: PAGE_SIZE, before } });
      const next = data.items || [];
      setItems((arr) => [...arr, ...next]);
      setHasMore(next.length === PAGE_SIZE);
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => { load(); }, []);

  const onPosted = (p) => setItems((arr) => [p, ...arr]);
  const onDeleted = (id) => setItems((arr) => arr.filter((p) => p.id !== id));

  return (
    <DashboardShell>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6" data-testid="news-feed-page">
        <div className="space-y-5">
          <div>
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.32em] text-[#39ff14]">// Home</div>
            <h1 className="text-2xl lg:text-3xl font-semibold mt-1">News Feed</h1>
          </div>

          <PostComposer onPosted={onPosted} />

          {loading ? (
            <FeedSkeleton count={3} />
          ) : items.length === 0 ? (
            <div className="csc-card p-8 text-center text-[#94a3b8]" data-testid="empty-feed">
              <p className="text-sm">
                Your feed is empty. Follow some organizations or people, or create your first post above.
              </p>
            </div>
          ) : (
            <>
              {items.map((p) => (
                <PostCard key={p.id} post={p} onDeleted={onDeleted} onUpdated={(u) => setItems((arr) => arr.map((x) => x.id === u.id ? u : x))} />
              ))}
              {hasMore && (
                <div className="text-center py-4">
                  <button onClick={loadMore} disabled={loadingMore} className="csc-btn-ghost" data-testid="load-more-feed">
                    {loadingMore ? "Loading…" : "Load more"}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <aside className="space-y-5 hidden lg:block">
          <TrendingHashtags />
          <SuggestedAccounts />
        </aside>
      </div>
      <BackToTop />
    </DashboardShell>
  );
}
